// semeia-disable-reexport
import templateOnly from "@ember/component/template-only";
const MyComponent = templateOnly();
export default MyComponent;
